import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium leading-6 text-gray-900"
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['relative mt-2 sm:mt-0 rounded-md shadow-sm'])
}
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}
const _hoisted_5 = {
  key: 0,
  class: "text-xs mt-1 text-red-600 sm:col-span-2 sm:items-end sm:col-start-2"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import { useField } from "vee-validate";
import { onMounted, PropType, Ref, ref } from "vue";
import i18n from "@/i18n";
import numberService from "@/services/numberService";


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatField',
  props: {
  name: {
    type: String as PropType<string>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    required: false,
  },
  precision: {
    type: Number as PropType<number>,
    required: false,
    default: 2,
  },
},
  setup(__props) {

const locale = (i18n.global.locale as unknown as Ref<string>).value;

const props = __props;

const valueText = ref<string>("");

const { value, setValue, errorMessage } = useField<number | null>(props.name);

const formatNumber = (value: number | null) => {
  if (value === null || !Number.isFinite(value)) {
    return "";
  }
  return value.toLocaleString(locale, {
    minimumFractionDigits: props.precision,
    maximumFractionDigits: props.precision,
    useGrouping: false,
  });
};

const handleBeforeInput = (event: Event) => {
  const inputEvent = event as InputEvent;
  if (inputEvent.data && !inputEvent.data.match(/\d|-|\.|,/)) {
    event.preventDefault();
  }
};

const handleInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  valueText.value = value;
  setValue(value ? numberService.parseText(value, props.precision) : null);
};

onMounted(() => {
  valueText.value = formatNumber(value.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (__props.label || _ctx.$slots.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            _renderSlot(_ctx.$slots, "label")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "text",
          name: __props.name,
          class: _normalizeClass(["outline-none block w-full rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset focus:ring-2 focus:ring-inset text-sm sm:leading-6", 
            _unref(errorMessage)
              ? ['text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500 pr-3']
              : ['text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-orange-300 pr-3']
          ]),
          onBeforeinput: handleBeforeInput,
          onInput: handleInput,
          value: valueText.value,
          autocomplete: "one-time-code"
        }, null, 42, _hoisted_3),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(ExclamationCircleIcon), {
                class: "h-5 w-5 text-red-500",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})